import React from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import dynamic from 'next/dynamic'

import {t} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))
const ContactForm = dynamic(() => import('@components/ContactForm'))

const Contact = ({isRecaptchaValidated}) => {
  return (
    <React.Fragment>
      <Meta title={`${t('pages.contact.title')} – ${t('layout.title')}`} />

      <div className='Contact'>
        <DualSlide freeHeight>
          <div
            className={className('DualSlide__wrapper DualSlide__content--10', {
              'DualSlide__wrapper--h1': true,
              'DualSlide__wrapper--h1--contact': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.contact.dualslide.0.h2'),
                }}
              />

              <div className='Contact__left'>
                <div className='Contact__left__item'>
                  <div className='Contact__left__item__header'>
                    <h3 className='Contact__left__h3'>
                      {t('pages.contact.dualslide.0.branches.0.h3')}
                    </h3>
                  </div>

                  <p className='DualSlide__p'>
                    {t('pages.contact.dualslide.0.branches.0.p')}
                  </p>

                  <div className='Contact__left__tel-mail'>
                    <a className='Contact__left__tel' href='tel:020245560'>
                      {t('layout.Footer.tl.tel')}
                    </a>

                    <a
                      className='Contact__left__email'
                      href={`mailto:${t('layout.Footer.tl.email')}`}
                    >
                      {t('layout.Footer.tl.email')}
                    </a>
                  </div>

                  <iframe
                    className='Contact__left__iframe'
                    src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.072195349628!2d100.58990201483007!3d13.714077190371894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29feb33e83421%3A0xfe14120eb3d8af4f!2sData%20Wow!5e0!3m2!1sen!2sth!4v1585543617852!5m2!1sen!2sth'
                    frameBorder='0'
                    allowFullScreen
                  />
                </div>

                <div className='Contact__left__item'>
                  <div className='Contact__left__item__header'>
                    <h3 className='Contact__left__h3'>
                      {t('pages.contact.dualslide.0.branches.1.h3')}
                    </h3>

                    <small className='Contact__left__item__header__small'>
                      Nanameue inc
                    </small>
                  </div>

                  <p className='DualSlide__p DualSlide__p--small'>
                    {t('pages.contact.dualslide.0.branches.1.p')}
                  </p>

                  <div className='Contact__left__tel-mail-flex'>
                    <a
                      className='Contact__left__tel Contact__left__tel--small'
                      href='tel:+81367211076'
                    >
                      Tel: +81-3-6721-1076
                    </a>

                    <a
                      className='Contact__left__email'
                      href={'mailto:ai@nanameue.jp'}
                    >
                      Email: ai@nanameue.jp
                    </a>
                  </div>

                  <iframe
                    className='Contact__left__iframe'
                    src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.2830169768336!2d139.72809261525842!3d35.670032680196925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b5611315555%3A0xf111d6e4ba879701!2snanameue%2C%20Inc.!5e0!3m2!1sen!2sus!4v1610436834434!5m2!1sen!2sus'
                    frameBorder='0'
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--h1': true,
              'DualSlide__wrapper--h1--contact': true,
              'DualSlide__wrapper--h1--contact-green': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <div className='Contact__right'>
                <h3 className='Contact__right__h3'>
                  {t('pages.contact.dualslide.1.h3')}
                </h3>

                <p className='Contact__right__p'>
                  {t('pages.contact.dualslide.1.p')}
                </p>

                <ContactForm alt isRecaptchaValidated={isRecaptchaValidated} />
              </div>
            </div>
          </div>
        </DualSlide>
      </div>
    </React.Fragment>
  )
}

Contact.propTypes = {}

export default Contact
